import { render, staticRenderFns } from "./BridgeDeeplink.vue?vue&type=template&id=514a5d54&scoped=true&"
import script from "./BridgeDeeplink.vue?vue&type=script&lang=js&"
export * from "./BridgeDeeplink.vue?vue&type=script&lang=js&"
import style0 from "./BridgeDeeplink.vue?vue&type=style&index=0&id=514a5d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514a5d54",
  null
  
)

export default component.exports